import { Form } from 'react-bootstrap';

type ParamSwitchProps = {
    id: string;
    label: string;
    description?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (checked: boolean) => void;
};

const ParamSwitch = ({ id, label, description, checked, disabled, onChange }: ParamSwitchProps) => (
    <div
        className={`d-flex justify-content-between align-items-start gap-3 py-3 ${
            disabled ? 'opacity-50' : ''
        }`}
    >
        <div className="pe-2" style={{ maxWidth: 520 }}>
            <label htmlFor={id} className="form-check-label fw-semibold mb-0">
                {label}
            </label>
            {description ? <div className="text-muted fs-12 mt-1">{description}</div> : null}
        </div>
        <Form.Check
            id={id}
            type="switch"
            className="flex-shrink-0 mt-1"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
        />
    </div>
);

export default ParamSwitch;
